import React, { useEffect } from "react";
import { verifyCookie } from "../../features/authentication/authenticationAPI";
import {
  LogoutParams,
  logoutWithRedirect,
} from "../../features/authentication/authenticationSlice";
import { useAppDispatch } from "../../hooks/hooks";
import { sendMemberEventAsync } from "../../features/admin/adminSlice";

export interface GatekeeperProps {
  logMemberEvent?: boolean;
  pageName: string;
}

const gateKeeper = <P extends {}>(Component: React.ComponentType<P>) => {
  const Gatekeeper: React.FC<P & GatekeeperProps> = props => {
    const dispatch = useAppDispatch();
    const handleLogout = (LogoutParams: LogoutParams) => {
      dispatch(logoutWithRedirect(LogoutParams));
    };

    useEffect(() => {
      if (props.logMemberEvent) {
        sendMemberEvent();
      }
      verifyCookie().catch(error => {
        handleLogout({
          location: "gateKeeper.verifyCookieCatch",
          logError: error,
        });
        console.log("Error verifying Authentication:", error);
      });
    });

    const sendMemberEvent = () => {
      dispatch(
        sendMemberEventAsync({
          EventCategory: props.pageName,
          EventAction: "page",
        }),
      );
    };

    return <Component {...props} />;
  };
  return Gatekeeper;
};

export default gateKeeper;
